// Reactインポート
import React, { useState } from "react";

import { Helmet, HelmetProvider } from 'react-helmet-async'

// ゲットナビゲータ
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ScrollToTop from "../ScrollToTop";

// タブページ
import HomePageTab from "./w-tabs/HomePage";
import GraphicDesignTab from "./w-tabs/GraphicDesign";
import Tabs from "./w-tabs/Tabs";

// スタイルインポート
import "../pages/css/works.scss";
import "../responsive/WorksResponsive.scss";
import "../common.scss";

// メインビジュアル
import headerSubImg from "../img/works/works-img.jpg";

// framer motion
import { motion } from "framer-motion";

function Works() {
  return (
    <motion.div
      className="works"
      initial={{ width: 0 }}
      animate={{ width: "100%" }}
      exit={{ x: window.innerWidth, transition: { duration: 0.1 } }}
    >
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#005bac" />
        <meta
          name="keywords"
          content="千葉県千葉市web制作,千葉市格安ホームページ制作,千葉市web集客,smartgenz,パドリナアレン,smartgenzとは？"
        />
        <meta
          name="description"
          content="SmartGenz（スマートジェンズ）はこれまでに手掛けたプロジェクトをご紹介します。
          私たちの仕事は、高品質なデザインを制作し、ビジネスを次のレベルへと導く柱となること、新たな潜在顧客の獲得という原則を大切にしています。私たちは、「自然に集まってくるものを創る」をモットーに、優れた顧客サービスとマーケティング支援を軸にして様々な案件を完成させてきました。その結果、地域内で注目される飲食店、サービス、オフィス、小売業等を構築できました。"
        />
        <meta property="og:title" content="千葉県千葉市でのホームページ制作ならSmartGenz | 制作事例" />
        <meta
          property="og:description"
          content="SmartGenz（スマートジェンズ）はこれまでに手掛けたプロジェクトをご紹介します。
          私たちの仕事は、高品質なデザインを制作し、ビジネスを次のレベルへと導く柱となること、新たな潜在顧客の獲得という原則を大切にしています。私たちは、「自然に集まってくるものを創る」をモットーに、優れた顧客サービスとマーケティング支援を軸にして様々な案件を完成させてきました。その結果、地域内で注目される飲食店、サービス、オフィス、小売業等を構築できました。"
        />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://smartgenz.com/works" />
        <meta property="og:image" content="%PUBLIC_URL%/smartgenz.jpg" />
        <meta property="og:site_name" content="千葉県千葉市でのホームページ制作ならSmartGenz | 制作事例" />
        <meta property="og:locale" content="ja_JP" />
        <link rel="apple-touch-icon" href="%PUBLIC_URL%/smartgenz.jpg" />
        <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
        <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
        <link rel="canonical" href="https://smartgenz.com/works" />
        <title>千葉県千葉市でのホームページ制作ならSmartGenz | 制作事例</title>
        </Helmet>
		  </HelmetProvider>
      <article className="sub-image">
        <div className="sub-main-image position-about">
          <img
            src={headerSubImg}
            alt="アイテム　｜ ヘッダーイメージ"
          ></img>
        </div>
      </article>
      <ScrollToTop />
      <section className="wrk-sec">
        <div className="sub-sec-company-ttl">
          <div className="borderA"></div>
          <h2 data-desc="制作事例">WORKS</h2>
          <div className="borderB"></div>
        </div>
      </section>
      <Tabs />
      <Contact />
      <Footer />
    </motion.div>
  );
}

export default Works;
